import { call, put, takeEvery } from "redux-saga/effects";

// Crypto Redux States
import {
  ADD_NEW_INTERNALSAMPLE,
  DELETE_INTERNALSAMPLE,
  GET_INTERNALSAMPLES,
  UPDATE_INTERNALSAMPLE,
  UPDATE_INTERNALSAMPLE_STATUS
} from "./actionTypes";

import {
  addInternalSampleFail,
  addInternalSampleSuccess,
  deleteInternalSampleFail,
  deleteInternalSampleSuccess,
  getInternalSamplesFail,
  getInternalSamplesSuccess,
  setState,
  updateInternalSampleFail,
  updateInternalSampleSuccess,
} from "./actions";

import { internalSamples, updateStatus } from '../../../helpers/adipiBackendUrl';
import { deleteApiCall, getTable, patchApiCall, postApiCall } from "../../../services/mainServices";

function* fetchInternalSamples({ payload: { params } }) {
  try {
    yield put(setState(true));
    const response = yield call(getTable, internalSamples, params.toString());
    yield put(setState(false));
    yield put(getInternalSamplesSuccess(response.items, response.totalPages, response.currentPage));
  } catch (error) {
    yield put(setState(false));
    yield put(getInternalSamplesFail(error));
  }
}

function* updateInternalSample({ payload: internalSampleObj }) {
  try {
    const { id, recordStatus, ...rest } = internalSampleObj;
    yield call(patchApiCall, `${internalSamples}/${id}`, rest);
    const response = yield call(getTable, `${internalSamples}/${internalSampleObj.id}`);
    yield put(updateInternalSampleSuccess(response));
  } catch (error) {
    yield put(updateInternalSampleFail(error));
  }
}

function* updateInternalSampleStatus({ payload: internalSampleObj }) {
  try {
    const { id } = internalSampleObj;
    yield call(patchApiCall, `${internalSamples}/${updateStatus}/${id}`, { recordStatus: internalSampleObj.recordStatus });
    const response = yield call(getTable, `${internalSamples}/${internalSampleObj.id}`);
    yield put(updateInternalSampleSuccess(response));
  } catch (error) {
    yield put(updateInternalSampleFail(error));
  }
}

function* deleteInternalSample({ payload: internalSampleObj }) {
  try {
    yield call(deleteApiCall, `${internalSamples}/${internalSampleObj.id}`);
    yield put(deleteInternalSampleSuccess(internalSampleObj.id));
  } catch (error) {
    yield put(deleteInternalSampleFail(error));
  }
}

function* postingInternalSample({ payload: internalSample }) {
  try {
    const response = yield call(postApiCall, internalSamples, internalSample);
    yield put(addInternalSampleSuccess(response));
  } catch (error) {
    yield put(addInternalSampleFail(error));
  }
}

function* internalSamplesSaga() {
  yield takeEvery(GET_INTERNALSAMPLES, fetchInternalSamples);
  yield takeEvery(ADD_NEW_INTERNALSAMPLE, postingInternalSample);
  yield takeEvery(UPDATE_INTERNALSAMPLE, updateInternalSample);
  yield takeEvery(UPDATE_INTERNALSAMPLE_STATUS, updateInternalSampleStatus);
  yield takeEvery(DELETE_INTERNALSAMPLE, deleteInternalSample);
}

export default internalSamplesSaga;
